import { render, staticRenderFns } from "./Peoples.vue?vue&type=template&id=296f524c&scoped=true"
import script from "./Peoples.vue?vue&type=script&setup=true&lang=js"
export * from "./Peoples.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Peoples.vue?vue&type=style&index=0&id=296f524c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296f524c",
  null
  
)

export default component.exports